module.exports = __webpack_public_path__ + "img/banner-desktop.525a3417.png";